module.exports = __webpack_public_path__ + "static/media/employee_image.d319620f.png";